module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal"
  }, [_c('div', {
    staticClass: "sub-header container-fluid"
  }, [_c('div', {
    staticClass: "title"
  }), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('md-input-container', [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1)], 1), _vm._v(" "), _c('md-icon', {
    class: {
      'active': _vm.showSidebar
    },
    nativeOn: {
      "click": function($event) {
        _vm.showSidebar = !_vm.showSidebar
      }
    }
  }, [_vm._v("category")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "portal-apps-container"
  }, [_c('div', {
    staticClass: "portal-apps",
    class: {
      'sidebarShown': _vm.showSidebar
    }
  }, _vm._l((_vm.filteredApps), function(app, index) {
    return (_vm.groupedApps && _vm.hasCategory(app.Category) && app.Category !== 'Admin') ? _c('div', {
      key: index,
      staticClass: "portal-app flip-container",
      attrs: {
        "ontouchstart": "this.classList.toggle('hover');"
      }
    }, [_c('div', {
      staticClass: "flipper"
    }, [_c('div', {
      staticClass: "front"
    }, [_c('div', {
      staticClass: "portal-app"
    }, [_c('div', {
      staticClass: "portal-app__image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImageSrc(app.image),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "portal-app__image-placeholder"
    }, [_vm._v("WB")])]), _vm._v(" "), _c('div', {
      staticClass: "portal-app__name"
    }, [_vm._v(_vm._s(app.Name))])])]), _vm._v(" "), _c('div', {
      staticClass: "back"
    }, [_c('div', {
      staticClass: "portal-app"
    }, [(app.apps) ? _c('div', {
      staticClass: "portal-app__envs"
    }, [_c('div', {
      staticClass: "app__env",
      class: {
        disabled: !_vm.isEnvActive('Develop', app.apps)
      },
      on: {
        "click": function($event) {
          _vm.forward(_vm.getAppByEnv('Develop', app.apps))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../uiassets/icons/icon-dev.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Dev\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "app__env",
      class: {
        disabled: !_vm.isEnvActive('Test', app.apps)
      },
      on: {
        "click": function($event) {
          _vm.forward(_vm.getAppByEnv('Test', app.apps))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../uiassets/icons/icon-test.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Test\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "app__env",
      class: {
        disabled: !_vm.isEnvActive('Acceptance', app.apps)
      },
      on: {
        "click": function($event) {
          _vm.forward(_vm.getAppByEnv('Acceptance', app.apps))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../uiassets/icons/icon-acceptance.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Acc\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "app__env",
      class: {
        disabled: !_vm.isEnvActive('Production', app.apps)
      },
      on: {
        "click": function($event) {
          _vm.forward(_vm.getAppByEnv('Production', app.apps))
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../uiassets/icons/icon-live.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                    Live\n                                ")])]) : _c('div', {
      staticClass: "portal-app__no-envs",
      on: {
        "click": function($event) {
          return _vm.forward(app)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../uiassets/icons/icon-open-app.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('br'), _vm._v("\n                                Open app\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "portal-app__name"
    }, [_vm._v(_vm._s(app.Name))])])])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-left",
      "enter-active-class": "slideAppear",
      "leave-active-class": "slideDisappear"
    }
  }, [(_vm.showSidebar) ? _c('div', {
    staticClass: "portal-apps-sidebar"
  }, [_c('div', {
    staticClass: "categories-title"
  }, [_vm._v("\n                    Categories\n                    "), _c('md-icon', {
    staticClass: "close-categories",
    nativeOn: {
      "click": function($event) {
        _vm.showSidebar = false
      }
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _vm._l((_vm.categories), function(cat, index) {
    return _c('div', {
      staticClass: "category"
    }, [_c('div', {
      staticClass: "md-checkbox md-theme-default",
      class: {
        'md-checked': _vm.localSelectedCategories.includes(cat)
      },
      attrs: {
        "value": cat
      }
    }, [_c('div', {
      staticClass: "md-checkbox-container",
      attrs: {
        "tabindex": "0"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localSelectedCategories),
        expression: "localSelectedCategories"
      }],
      attrs: {
        "type": "checkbox",
        "tabindex": "-1",
        "id": (cat + "-" + index)
      },
      domProps: {
        "value": cat,
        "checked": Array.isArray(_vm.localSelectedCategories) ? _vm._i(_vm.localSelectedCategories, cat) > -1 : (_vm.localSelectedCategories)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.localSelectedCategories,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = cat,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.localSelectedCategories = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.localSelectedCategories = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.localSelectedCategories = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "md-checkbox-label",
      attrs: {
        "for": (cat + "-" + index)
      }
    }, [_vm._v(_vm._s(cat))])])])
  })], 2) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3eab9e33!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portal.vue
// module id = 308
// module chunks = 2